import useDelay from '@src/hooks/utils/useDelay';
import { PreloadableComponent } from '@src/utils/lazyWithPreload';
import { useEffect } from 'react';

interface UsePreloadComponentOptions {
  /**
   * Delay in milliseconds
   */
  delay?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Component: PreloadableComponent<(props?: any) => JSX.Element> | undefined;
}

const usePreloadComponent = (options: UsePreloadComponentOptions) => {
  const { Component, delay = 3000 } = options;

  const { isSettled } = useDelay({ delay });

  useEffect(() => {
    if (isSettled) {
      if (Component) {
        Component.preload();
      }
    }
  }, [isSettled]);
};

export default usePreloadComponent;
